import { Component } from '@angular/core';
import { ChatCardComponent } from '../common/chat-card/chat-card.component';

@Component({
  selector: 'app-agents',
  imports: [ChatCardComponent],
  templateUrl: './agents.component.html',
  styleUrl: './agents.component.scss',
})
export class AgentsComponent {}
